import {createMuiTheme, responsiveFontSizes} from '@material-ui/core/styles'

const muiTheme = createMuiTheme({
    spacing: 8, //  default, Material Design recommendation
    typography: {
        fontFamily: 'Montserrat',
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        useNextVariants: true,
        h4: {
            font: 'Bold 1.875rem/2.3125rem Montserrat',
            fontWeight: '700',
            letterSpacing: 0,
            color: '#262626',
            opacity: 1,
        },
        h5: {
            font: 'Bold 1.625rem/2rem Montserrat',
            fontWeight: '600',
            letterSpacing: 0,
            color: '#098447',
            opacity: 1,
        },
        h6: {
            font: 'Bold 1.375rem/1.6875rem Montserrat',
            fontWeight: '600',
            letterSpacing: 0,
            color: '#098447',
            opacity: 1,
        },
        subtitle1: {
            font: 'Bold 1.0625rem/1.3125rem Montserrat',
            fontWeight: '700',
            letterSpacing: 0,
            color: '#098447',
            opacity: 1,
        },
        body1: {
            font: 'Regular 1rem/1.3125 Montserrat',
            letterSpacing: 0,
            color: '#262626',
            opacity: 1,
            bold: {
                fontWeight: '700',
            },
        },
        body2: {
            font: 'Regular 0.8125rem/1.1875rem Montserrat',
            letterSpacing: 0,
            color: '#262626',
            opacity: 1,
        },
        overline: {
            font: 'Bold 0.75rem/0.9375rem Montserrat',
            fontWeight: '700',
            letterSpacing: 0,
            color: '#B7B7B7',
            textTransform: 'uppercase',
            opacity: 1,
        },
        button: {
            font: 'Bold 0.875rem/1.125rem Montserrat',
            fontWeight: '700',
            letterSpacing: 0,
            color: '#FFFFFF',
            textTransform: 'uppercase',
            opacity: 1,
        },
        hyperlink: {
            font: 'Regular 1rem/1.3125rem Montserrat',
            letterSpacing: 0,
            color: '#098447',
            opacity: 1,
        },
    },
    palette: {
        text: {
            primary: '#262626',
        },
        background: {
            paper: '#FFFFFF',
            default: '#FFFFFF',
        },
        common: {
            black: '#262626',
            white: '#FFFFFF',
        },
        primary: {
            main: '#098447',
            contrastText: '#fff',
        },
        secondary: {
            main: '#02AB77',
            contrastText: '#fff',
        },
        success: {
            main: '#02AB77',
            secondary: '#E1F5EF',
            borderColor: '#02AB77',
            contrastText: '#000000',
        },
        error: {
            main: '#F96157',
            secondary: '#FEF3F2',
            borderColor: '#F96157',
            contrastText: '#000000',
        },
        warning: {
            main: '#EBB53E',
            secondary: '#FBF3DE',
            borderColor: '#EBB53E',
            contrastText: '#000000',
        },
        message: {
            main: '#4EB9B9',
            secondary: '#02AB77',
            borderColor: '#4EB9B9',
            contrastText: '#000000',
        },
        info: {
            main: '#4EB9B9',
            secondary: '#E4F5F5',
            borderColor: '#4EB9B9',
            contrastText: '#000000',
        },
        green: {
            pale: '#DDF1E9',
            light: '#B5DAC8',
            medium: '#098447',
            dark: '#04672F',
        },
        grey: {
            pale: '#F2F2F2',
            light: '#DBDBDB',
            medium: '#B7B7B7',
            dark: '#707070',
            darkest: '#262626',
        },
    },
    props: {
        MuiButtonBase: {
            disableRipple: true,
            boxshadow: 'none',
        },
    },
})

export default responsiveFontSizes(muiTheme)
